import {
  FORSUBMIT,
  UNITS,
  GET,
  CREATE,
  UPDATE,
  DELETE,
  CURRENT,
  GET_PARTY_EXERCISES
} from '@hobs/constants/parties';
import { actionCreator } from './utils/utils';

export const getPartyCreateForSubmit = () =>
  actionCreator('parties/forSubmit', FORSUBMIT);
export const getPartyUnits = partyId =>
  actionCreator(`parties/${partyId}/Units`, UNITS);
export const createParty = party =>
  actionCreator('parties', CREATE, { body: party, method: 'POST' });
export const getParty = partyId => actionCreator(`Parties/${partyId}`, GET);
export const updateParty = requestBody =>
  actionCreator('Parties', UPDATE, { body: requestBody, method: 'PUT' });
export const deleteParty = partyId =>
  actionCreator(`Parties/${partyId}`, DELETE, { method: 'DELETE' });
export const getCurrentParty = () => actionCreator(`Parties/current`, CURRENT);
export const getPartyExercises = partyId =>
  actionCreator(`Parties/${partyId}/Exercises`, GET_PARTY_EXERCISES);
